import metaApiClient from './meta-client';
import type { AiKey, AiKeyCreate, AiKeyUpdate } from '@/types/aiKey';

// ========== AI KEYS API ==========

// List all AI keys
export const getAiKeys = async (): Promise<AiKey[]> => {
    const response = await metaApiClient.get<AiKey[]>('/meta/ai-keys');
    return response.data;
};

// Get a specific AI key
export const getAiKey = async (id: number): Promise<AiKey> => {
    const response = await metaApiClient.get<AiKey>(`/meta/ai-keys/${id}`);
    return response.data;
};

// Create a new AI key
export const createAiKey = async (data: AiKeyCreate): Promise<AiKey> => {
    const response = await metaApiClient.post<AiKey>('/meta/ai-keys', data);
    return response.data;
};

// Update an existing AI key
export const updateAiKey = async (id: number, data: AiKeyUpdate): Promise<AiKey> => {
    const response = await metaApiClient.put<AiKey>(`/meta/ai-keys/${id}`, data);
    return response.data;
};

// Delete an AI key
export const deleteAiKey = async (id: number): Promise<void> => {
    await metaApiClient.delete(`/meta/ai-keys/${id}`);
};
